namespace Areas.Project.Building {
    "use strict";

    export function goToBuildingFromBuildingGrid() {
        gotoSelected("BuildingDataGrid", "/Building/Profile/View/");
    }

    export function newBuildingProject(e: any) {
        setProjectId("BuildingDataGrid", e);
    }    

    export function columnViewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.buildingId; },
            "<a href= '/Building/Profile/View/{placeholder}'>View</a>");
    } 
    
    export function buildingEditTemplate(cellElement: any, cellInfo: any) {
        var storeConfiguration = {
            "loadParams": {},
            "key": "buildingId",
            "loadUrl": "/Project/Building/GetBuildings",
            "insertUrl": "",
            "updateUrl": "",
            "deleteUrl": ""
        };

        var store = DevExpress.data.AspNet.createStore(storeConfiguration);

        const dataSource = new DevExpress.data.DataSource({
            store: store
        });

        var div = document.createElement("div");
        cellElement.get(0).appendChild(div);
        $(div).dxLookup({
            dataSource: dataSource,
            valueExpr: "buildingId",
            displayExpr: (data:any) => data ? data.caan + ' ' + data.name : "Select...",
            value: cellInfo.data.buildingId,
            searchExpr: ["caan", "name"],

            onValueChanged(e) {
                cellInfo.setValue(e.value);
            }
        });

        $(div).dxLookup("instance").option("itemTemplate", buildingLookupTemplate);
        $(div).dxLookup("instance").option("popupWidth", 500);       
    }

    export function buildingLookupTemplate(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div style="width:400px;"><span class="collookupspan" style="width:80px;">${itemData.caan}</span>${itemData.name}</div>`);
    }

    function setProjectId(gridName: string, e: any) {
        const dataGrid = $(`#${gridName}`).dxDataGrid("instance");
        const projectId = dataGrid.option("projectId");

        e.data.projectId = projectId;        
    }    

}
